import React from 'react'
import { connect } from 'react-redux';
import Wix from 'Wix';
import { BoxContainer } from '../style'
import ButtonCaption from '../ButtonCaption'
import TextCaption from '../TextCaption'
import SubBox from './SubBox';
import { getOpacityForBoxBorder } from '../../../../../editSlide/api/boxUtils';
import { getFigure } from '../../../../../Utils/boxFigureUtils'
import { convertMobileUmitableFields, getDiffToMobileConvert } from '../../../../../editSlide/api/converter';
import ShapeCaption from '../ShapeCaption';
import { getBackgroundGradient } from '../../../../../Utils/utils';
import { getRightPropertyValue } from '../../../../../Utils/helpers';
import { RenderSvgShape } from '../../../../../Utils/svgShapes';
import ImageCaption from '../ImageCaption';

class BoxCaption extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            boxStyle: {
                backgroundColor: null,
                borderColor: null,
                borderWidth: null,
                borderRadius: null,
                width: null,
                height: null,

                position: {
                    x: null,
                    y: null,
                },
            },
        }
    }

    componentWillMount() {
        this.setState({
            boxStyle: this.getBoxStyle(this.props.box),
            // figure: getFigure(this.props.box.pointsArray),
        })
    }

    getBoxStyle(box) {
        const deviceType = Wix.Utils.getDeviceType()
        const isMobile = deviceType === 'mobile'
        const desktopDims = this.props.slide === undefined ? { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight } : { width: this.props.slide.editedWidth, height: this.props.slide.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (deviceType === 'mobile') {
            const { mobileDiffW, mobileDiffH } = getDiffToMobileConvert(
                this.props.widgetDimensions.width,
                this.props.widgetDimensions.height,
                this.props.widgetDimensions.mobileWidth,
                this.props.widgetDimensions.mobileHeight,
            )
            const maxDiff = mobileDiffW > mobileDiffH ? mobileDiffW : mobileDiffH
            box = convertMobileUmitableFields(_.cloneDeep(box), mobileDiffW, mobileDiffH, maxDiff)
        }
        let borderRadiusProperty, borderWidthProperty, fontSizeProperty, lineHeightProperty,
            paddingProperty, widthProperty, positionProperty, heightProperty;
        switch (deviceType) {
            case 'desktop':
                borderRadiusProperty = 'borderRadius';
                borderWidthProperty = 'borderWidth';
                fontSizeProperty = 'fontSize';
                lineHeightProperty = 'lineHeight';
                paddingProperty = 'padding';
                widthProperty = 'width';
                heightProperty = 'height';
                positionProperty = 'position';
                break;

            case 'mobile':
                borderRadiusProperty = 'mobileBorderRadius';
                borderWidthProperty = 'mobileBorderWidth';
                fontSizeProperty = 'mobileFontSize';
                lineHeightProperty = 'mobileLineHeight';
                paddingProperty = 'mobilePadding';
                widthProperty = 'mobileWidth';
                heightProperty = 'mobileHeight';
                positionProperty = 'mobilePosition';
                break;
        }

        const needMobileConvert = box.needMobileConvert || false

        let captionPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, box, 1, '', true, needMobileConvert)
        if (box.boxId !== '' && isMobile && box.mobilePosition && box.mobilePosition.relativeX == undefined) {
            const clonedCaption = _.cloneDeep(box)
            delete clonedCaption.mobilePosition
            const convertedPosition = getRightPropertyValue(desktopDims, mobileDims, 'position', isMobile, clonedCaption, 1, '', true, needMobileConvert)
            captionPosition = {
                ...captionPosition,
                relativeX: convertedPosition.relativeX,
                relativeY: convertedPosition.relativeY
            }
        }
        const xProp = box.boxId === '' ? 'x' : 'relativeX'
        const yProp = box.boxId === '' ? 'y' : 'relativeY'

        // let boxStyle = {
        //     backgroundColor: box.backgroundColor,
        //     borderColor: box.borderColor,
        //     // borderColor: getOpacityForBoxBorder(box.backgroundColor, box.borderColor),
        //     borderRadius: box[borderRadiusProperty],
        //     borderWidth: box[borderWidthProperty],
        //     width: box[widthProperty],
        //     height: box[heightProperty],
        //     shadow: !box.hasShadow ? '' : `${box.shadow.x}px ${box.shadow.y}px ${box.shadow.blur}px ${box.shadow.size}px ${box.shadow.color}`,
        //     position: {
        //         x: box.boxId === '' ? box[positionProperty].x : box[positionProperty].relativeX,
        //         y: box.boxId === '' ? box[positionProperty].y : box[positionProperty].relativeY
        //     },
        //     zIndex: box.layer + 200,
        // }
        let boxStyle = {
            backgroundColor: box.backgroundColor,
            borderColor: box.borderColor,
            // borderColor: getOpacityForBoxBorder(box.backgroundColor, box.borderColor),
            borderRadius: getRightPropertyValue(desktopDims, mobileDims, 'borderRadius', isMobile, box, 1, '', true, needMobileConvert),
            borderWidth: getRightPropertyValue(desktopDims, mobileDims, 'borderWidth', isMobile, box, 1, '', true, needMobileConvert),
            width: getRightPropertyValue(desktopDims, mobileDims, 'width', isMobile, box, 1, '', true, needMobileConvert),
            height: getRightPropertyValue(desktopDims, mobileDims, 'height', isMobile, box, 1, '', true, needMobileConvert),
            shadow: !box.hasShadow ? '' : `${box.shadow.x}px ${box.shadow.y}px ${box.shadow.blur}px ${box.shadow.size}px ${box.shadow.color}`,
            position: {
                x: captionPosition[xProp],
                y: captionPosition[yProp]
            },
            zIndex: box.layer + 200,
        }

        return boxStyle
    }

    render() {
        const caption = this.props.box
        const deviceType = Wix.Utils.getDeviceType()
        const isMobile = deviceType === 'mobile'
        const boxStyle = this.state.boxStyle
        const unicalClassName = this.props.unicalClassName ? `caption-${this.props.slideIndex}-${this.props.captionIndex}-${this.props.unicalClassName} ` : ''
        const boxContainerStyles = {
            width: boxStyle.width,
            height: boxStyle.height,
            top: boxStyle.position.y,
            left: boxStyle.position.x,
            zIndex: boxStyle.zIndex,
        }
        const innerBoxContainerStyles = {
            borderColor: boxStyle.borderColor,
            borderRadius: `${boxStyle.borderRadius.leftTop}px ${boxStyle.borderRadius.rightTop}px ${boxStyle.borderRadius.rightBottom}px ${boxStyle.borderRadius.leftBottom}px`,
            boxShadow: boxStyle.shadow,
            borderWidth: boxStyle.borderWidth,
            background: getBackgroundGradient({ backgroundColor: boxStyle.backgroundColor }),
        }

        const hasCustomShape = caption.shape != 'rectangle' && caption.shape != undefined
        const borderRadius = boxStyle.borderRadius
        const borderWidth = boxStyle.borderWidth
        const borderColor = boxStyle.borderColor

        let svgShadow = ''

        const desktopDims = { width: this.props.widgetDimensions.editedWidth, height: this.props.widgetDimensions.editedHeight }
        const mobileDims = { width: this.props.widgetDimensions.mobileWidth, height: this.props.widgetDimensions.mobileHeight }
        if (caption.hasShadow) {
            svgShadow = `drop-shadow(${getRightPropertyValue(desktopDims, mobileDims, 'x', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue(desktopDims, mobileDims, 'y', isMobile, caption.shadow)}px `
                + `${getRightPropertyValue(desktopDims, mobileDims, 'blur', isMobile, caption.shadow)}px `
                + `${caption.shadow.color})`
        }
        const blur = getRightPropertyValue(desktopDims, mobileDims, 'blur', isMobile, caption)
        const glassEffect = getRightPropertyValue(desktopDims, mobileDims, 'glassEffect', isMobile, caption)
        return (
            <BoxContainer
                style={boxContainerStyles}
                hasCustomShape={hasCustomShape}
                borderRadius={innerBoxContainerStyles.borderRadius}
                blur={blur || 0}
                glassEffect={glassEffect || 0}
                grayscaleEffect={caption.grayscaleEffect || 0}
                invertEffect={caption.invertEffect || 0}
                effectType={caption.effectType || 'element'}
                id={`caption-${this.props.box.index}`}
                data-animation-in={this.props.animationIn || 'null'}
                className={`caption-container-${this.props.slideIndex}-${this.props.captionIndex} animated animate-${this.props.slideIndex}-${this.props.captionIndex} caption-${this.props.slideIndex}-${this.props.captionIndex} box ${unicalClassName}`}>
                <div
                    className={``}
                    style={hasCustomShape ? { border: 'none' } : innerBoxContainerStyles}
                >
                    {
                        hasCustomShape &&
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                cursor: 'move',
                                pointerEvents: 'none',
                                position: 'absolute'
                            }}
                        >
                            <RenderSvgShape
                                type={caption.shape}
                                dimensions={{ width: '100%', height: '100%' }}
                                backgroundColor={caption.backgroundColor}
                                backgroundColorType={caption.backgroundColor.type}
                                uid={caption.id}
                                borderRadius={borderRadius.leftTop || borderRadius.borderRadius}
                                stroke={borderWidth}
                                strokeColor={borderColor}
                                strokeType={caption.stroke || 'solid'}
                                style={{
                                    filter: svgShadow,
                                }}
                            />
                        </div>
                    }
                    {this.props.captions.map((caption, index) => {
                        if (caption.boxId === this.props.box.id) {
                            switch (caption.type) {
                                case 'button':
                                    return (
                                        <ButtonCaption caption={caption} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            lang={this.props.lang}
                                            locale={this.props.locale}
                                        />
                                    )
                                    break;

                                case 'box':
                                    return (
                                        <SubBox box={caption} captions={this.props.captions} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            lang={this.props.lang}
                                            locale={this.props.locale}
                                        />
                                    )
                                    break;

                                case 'shape':
                                    return (
                                        <ShapeCaption caption={caption} captions={this.props.captions} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                        />
                                    )
                                    break;

                                case 'image':
                                    return (
                                        <ImageCaption caption={caption} captions={this.props.captions} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                        />
                                    )
                                    break;

                                default:
                                    return (
                                        <TextCaption caption={caption} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            lang={this.props.lang}
                                            locale={this.props.locale}
                                        />
                                    )
                                    break;
                            }
                        }
                    })}
                </div>
            </BoxContainer>
        )
    }
}

export default BoxCaption;